/**
 * Shared "Meine Aufträge" sheet chrome styles.
 *
 * Moved verbatim out of `FleetOrdersBottomSheet.web.tsx` (PLA-861) so the PSP
 * view's sheet renders the same surface, handle, title and list paddings.
 * Values unchanged.
 *
 * @module components/fleetOrdersSheet.styles
 */

import { TextStyle, ViewStyle } from "react-native"

import { colors, spacing } from "@/theme"

// Styles
export const $bottomSheet: ViewStyle = {
  position: "absolute",
  bottom: 0,
  left: 0,
  right: 0,
  backgroundColor: colors.surface,
  borderTopLeftRadius: 24,
  borderTopRightRadius: 24,
  // @ts-ignore
  boxShadow: "0 -2px 12px rgba(17, 30, 44, 0.08)",
  elevation: 8,
  zIndex: 1000,
  overflow: "hidden",
  // @ts-ignore - Web-specific transition property
  transition: "height 0.3s ease-out",
}

export const $dragHandle: ViewStyle = {
  width: "100%",
  paddingTop: spacing.sm,
  cursor: "pointer" as any,
  // @ts-ignore
  transition: "background-color 150ms ease",
}

export const $pillHandleContainer: ViewStyle = {
  alignItems: "center",
  paddingVertical: 6,
}

export const $pillHandle: ViewStyle = {
  width: 36,
  height: 4,
  borderRadius: 2,
  backgroundColor: colors.palette.neutral350,
  // @ts-ignore
  transition: "background-color 150ms ease",
}

export const $pillHandleHovered: ViewStyle = {
  backgroundColor: colors.palette.neutral450,
}

export const $dragHandleContent: ViewStyle = {
  width: "100%",
  paddingHorizontal: spacing.xl,
  paddingBottom: spacing.xs,
}

export const $headerTitle: TextStyle = {
  fontSize: 22,
  fontWeight: "600",
  color: colors.text,
  marginBottom: 0,
}

export const $headerTitleMobile: TextStyle = {
  fontSize: 17,
  fontWeight: "600",
  color: colors.text,
  marginBottom: 0,
  flexShrink: 1,
}

export const $content: ViewStyle = {
  flex: 1,
  overflow: "hidden",
}

export const $listContent: ViewStyle = {
  paddingHorizontal: spacing.xl,
  paddingVertical: spacing.lg,
  paddingBottom: spacing.xxxl,
}

export const $emptyState: ViewStyle = {
  flex: 1,
  justifyContent: "center",
  alignItems: "center",
  paddingHorizontal: spacing.xl,
}

export const $emptyStateTitle: TextStyle = {
  fontSize: 18,
  fontWeight: "600",
  color: colors.text,
  marginTop: spacing.md,
  marginBottom: spacing.sm,
}

export const $emptyStateText: TextStyle = {
  fontSize: 14,
  color: colors.textDim,
  textAlign: "center",
  lineHeight: 22,
}
